import CompanyNameWithFlag from "./CompanyNameWithFlag";
import { openCompanyProfile } from "../services";
import { hasNoMatch } from "../utils";
import type { BulkMatchRow } from "../types";

type MatchedAgainstCellProps = {
  row: BulkMatchRow;
};

const MatchedAgainstCell = ({ row }: MatchedAgainstCellProps) => {
  if (hasNoMatch(row)) {
    return <div className="tw-h-full tw-px-3 tw-py-4 tw-text-sm tw-text-confidence-nomatch-text">No match found</div>;
  }

  return (
    <div className="tw-h-full tw-px-3 tw-py-2">
      <CompanyNameWithFlag name={row.matched_company?.name ?? ""} country={row.matched_company?.country} countryCode={row.matched_company?.country_code} onNameClick={() => openCompanyProfile(row.matched_company?.company_id)} nameClassName="tw-text-sm tw-text-primary-purple-600" countryClassName="tw-capitalize" />
    </div>
  );
};

export default MatchedAgainstCell;
